// src/Dashboard/pages/teacher/SuiviCompetitions/components/SuiviCompetitionsKpiCards.jsx

import React from "react";
import {
  FaCalendarCheck,
  FaCalendarTimes,
  FaClipboardList,
  FaTrophy,
  FaUsers,
} from "react-icons/fa";

const CARDS = [
  {
    key: "total",
    label: "Événements",
    icon: FaTrophy,
    tone:
      "bg-blue-50 text-blue-700 ring-blue-200 dark:bg-blue-900/20 dark:text-blue-200 dark:ring-blue-800/60",
  },
  {
    key: "upcoming",
    label: "À venir",
    icon: FaCalendarCheck,
    tone:
      "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-200 dark:ring-emerald-800/60",
  },
  {
    key: "past",
    label: "Passées",
    icon: FaCalendarTimes,
    tone:
      "bg-slate-50 text-slate-700 ring-slate-200 dark:bg-slate-800/60 dark:text-slate-200 dark:ring-slate-700",
  },
  {
    key: "withRegistrations",
    label: "Avec inscrits",
    icon: FaClipboardList,
    tone:
      "bg-violet-50 text-violet-700 ring-violet-200 dark:bg-violet-900/20 dark:text-violet-200 dark:ring-violet-800/60",
  },
  {
    key: "totalRegistrations",
    label: "Inscriptions",
    icon: FaUsers,
    tone:
      "bg-amber-50 text-amber-700 ring-amber-200 dark:bg-amber-900/20 dark:text-amber-200 dark:ring-amber-800/60",
  },
];

export default function SuiviCompetitionsKpiCards({ stats }) {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
      {CARDS.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.key}
            className={`rounded-2xl px-4 py-3 ring-1 ${card.tone}`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white/70 dark:bg-white/10">
                <Icon />
              </span>

              <span className="text-2xl font-bold">
                {stats?.[card.key] ?? 0}
              </span>
            </div>

            <p className="mt-2 text-xs font-bold uppercase tracking-wide opacity-80">
              {card.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}